module.exports = __webpack_public_path__ + "static/media/coktail.e5ff288d.jpg";